import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-root',
    template: `<router-outlet></router-outlet>`,
    standalone: false
})
export class AppComponent {
  constructor(
    private translate: TranslateService
  ) {
    
    const lang: string | null = window.localStorage.getItem('languagePreference');
    if(lang !== null){
      this.translate.setDefaultLang(lang); 
      this.translate.use(lang);
    } else{
      this.translate.setDefaultLang('sk'); 
      this.translate.use('sk');
      window.localStorage.setItem('languagePreference', 'sk');
    }
  }

}
